import React from 'react'
import { ActivityIndicator, Text, TouchableOpacity } from 'react-native'

/** Shared by game chat and inbox conversations. */
export function ChatSendButton({ onPress, disabled, loading = false, color, accessibilityLabel = 'Send message', size = 38 }: {
  onPress: () => void; disabled: boolean; loading?: boolean; color: string; accessibilityLabel?: string
  /** Diameter; the inline game-log composer uses a slimmer button. */
  size?: number
}) {
  return <TouchableOpacity onPress={onPress} disabled={disabled || loading} accessibilityLabel={accessibilityLabel} accessibilityRole="button"
    style={{ backgroundColor: color, alignItems: 'center', justifyContent: 'center', width: size, height: size, borderRadius: size / 2, opacity: disabled || loading ? 0.35 : 1, flexShrink: 0, marginBottom: 1 }}>
    {loading ? <ActivityIndicator size="small" color="#fff" /> : <Text style={{ color: '#fff', fontSize: Math.round(size * 0.47), lineHeight: Math.round(size * 0.53) }}>↑</Text>}
  </TouchableOpacity>
}
